export default {
	'.*SCHEDULE_A_TEST_DRIVE.*|.*INVENTORY_LEAD_SCHEDULE.*|.*SCHEDULETESTDRIVEFORM.*':
		'Test Drive',
	'.*SERVICE_XTIME_SCHEDULER_1.*|.*SERVICEAPPTFORM.*': 'Schedule Service',
	'.*SERVICE_LEAD.*': 'Service',
	'.*INVENTORY_LEAD_TRADE_IN.*': 'Trade In',
	'.*FINANCE_APPLICATION.*': 'Trade In',
	'.*FINANCE_LEAD.*|.*FINANCE_DEFAULT.*': 'Finance',
	'.*COMPARE.*': 'Compare',
	'.*REGIONAL_OFFERS.*': 'Regional Offers',
	'.*FPERFORMANCE.*': 'Custom Dealer Content',
	BUILD_YOUR_LEXUS: 'Build Your Lexus',
	'(.*PROMOTIONS_LANDING.*|.*INVENTORY_FEATURED_USED.*|.*PROMOTIONS_LISTING_NEW.*)':
		'Dealer Specials',
	'.*PROMOTIONS_LISTING_USED.*': 'Dealer Specials',
	'.*PROMOTIONS_LISTING_PARTS.*': 'Dealer Specials',
	'.*ABOUT.*': 'About Us',
	'.*DIRECTIONS_DEFAULT.*': 'Dealer Specials',
	'.*L_CERTIFIED.*': 'CPOV Program',
	'.*LEXUS_PLUS.*': 'Lexus Plus',
	'.*SHOWROOM.*': 'Model Showroom',
	'.*BRAKE_SERVICE.*|.*WIPER_BLADES.*': 'Parts',
	'.*COMPLIMENTARY_MAINTENANCE.*|.*OIL_CHANGE.*': 'Service',
	'.*TIRES.*': 'Tire Store',
	'.*SERVICE_SPECIALS.*': 'Service Specials',
	'.*PARTS_SPECIALS.*': 'Parts',
	'.*SERVICE_PARTS_SPECIALS.*': 'Parts',
	'.*SERVICE_BATTERIES.*': 'Parts',
	'.*SERVICE_PORTAL.*': 'Service'
};
